import * as React from 'react';
import { Error } from './error';

export const NotFoundError = (props) => <Error
    title='Trang tìm kiếm không tồn tại!'
    content='Vui lòng kiểm tra lại đường dẫn hoặc click vào nút bên dưới để quay về trang chính.'
/>